import { createAction } from '@reduxjs/toolkit';
import { onboardingSlice } from './reducer';

export const requestGetOnboardingState = createAction('onboarding/requestGetOnboardingState');

export const { successGetOnboardingState } = onboardingSlice.actions;
